module.exports = __webpack_public_path__ + "img/logo-full_milano.4cd3d96c.png";